var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineReceiptCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.5004L26 10.0004L24.5 11.5004L23 10.0004L21.5 11.5004L20 10.0004L18.5 11.5004L17 10.0004L15.5 11.5004L14 10.0004L12.5 11.5004L11 10.0004V30.0004L12.5 28.5004L14 30.0004L15.5 28.5004L17 30.0004L18.5 28.5004L20 30.0004L21.5 28.5004L23 30.0004L24.5 28.5004L26 30.0004L27.5 28.5004L29 30.0004V10.0004L27.5 11.5004ZM27 27.0904H13V12.9104H27V27.0904ZM14 23.0004H26V25.0004H14V23.0004ZM14 19.0004H26V21.0004H14V19.0004ZM14 15.0004H26V17.0004H14V15.0004Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineReceiptCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-receipt_circle-40px.ee6734a6c1c41f66d2c3158bef20b141.svg";
export { ForwardRef as ReactComponent };